import { Grid, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../helpers/generateUrl";
import {
    getCities,
    getDealer
} from "../../actions/GenomicsResearchAction";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);
interface Props {
    getCities: any;
    getDealer: any;
    dealer: any;
    cities: any;
}
const StopsPlace: React.FC<Props> = ({
    getCities,
    getDealer,
    dealer,
    cities,
}) => {
    const history = useHistory();
    const timer = useRef<any>(0);
    const [clientMobile, setClientMobile] = useState<any>("");
    const [city, setCity] = useState<any>("");
    const [clientEmail, setClientEmail] = useState<any>("")
    const [clients, setClients] = React.useState<any>();
    const [cityName, setCityName] = useState<any>("");
    const [firmName, setFirmName] = useState<any>("");
    const filterClientData = (e: any) => {
        const body: any = {
            name: clients,
            mobile: clientMobile,
            email: clientEmail,
            city: city,
            firmName:firmName,

        };
        const url = generateGenomicsResearchUrl(body).substring(2);
        getDealer(url);
    };
   
    return (
        <form style={{ width: "100%", marginLeft: 14 }} onSubmit={filterClientData}>
            <Grid container spacing={2} style={{ marginTop: 10 }}>
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    style={{ marginTop: 10 }}
                >
                    <Grid item xs={12} sm={4} md={2}>
                        <TextField
                            className="input"
                            name="name"
                            type="text"
                            label="Dealer Firm Name"
                            placeholder="Enter Mobile Number"
                            value={firmName}
                            variant="outlined"
                            onChange={(e) => setFirmName(e.target.value as string)}
                            style={{ width: "100%" }}
                            onKeyDown={(e)=>e.keyCode === 13?filterClientData(e):""}                          
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <TextField
                            className="input"
                            name="name"
                            type="text"
                            label="Dealer Owner Name"
                            placeholder="Search Dealer Name"
                            value={clients}
                            variant="outlined"
                            onChange={(e) => setClients(e.target.value as string)}
                            style={{ width: "100%" }}
                            onKeyDown={(e)=>e.keyCode === 13?filterClientData(e):""}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={4} md={2}>
                        <TextField
                            className="input"
                            name="name"
                            type="text"
                            label="Client Mobile Number"
                            placeholder="Enter Mobile Number"
                            value={clientMobile}
                            variant="outlined"
                            onChange={(e) => setClientMobile(e.target.value as string)}
                            style={{ width: "100%" }}
                        />
                    </Grid> */}
                    <Grid item xs={12} sm={4} md={2}>
                        <TextField
                            className="input"
                            name="name"
                            type="text"
                            label="Client Email"
                            placeholder="Enter Email ID"
                            value={clientEmail}
                            variant="outlined"
                            onChange={(e) => setClientEmail(e.target.value as string)}
                            style={{ width: "100%" }}
                            onKeyDown={(e)=>e.keyCode === 13?filterClientData(e):""}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <Autocomplete
                            id="City_Name"
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                                    setCity(obj.id);
                                }
                            }}
                            defaultValue={
                                { _id: "", name: cityName }
                            }
                            options={cities || []}
                            blurOnSelect
                            disableClearable={city === ""}
                            disableCloseOnSelect
                            getOptionLabel={(option: any) => `${option?.name}`}
                            onInputChange={(event, newInputValue) => {
                                clearTimeout(timer.current);
                                timer.current = setTimeout(() => {
                                    getCities(newInputValue);
                                }, 1000);
                                setCityName(newInputValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className="input"
                                    label="City"
                                    variant="outlined"
                                    placeholder="Select City"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            onClick={filterClientData}
                        >
                            Filter
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => history.go("/dashboard/gnre/dealer/create")}
                        >
                            Reset
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    cities: state.GenomicsCAReducer.cities,
    dealer: state.GenomicsCAReducer.dealer,
});
export default connect(mapStateToProps, {
    getCities,
    getDealer,
})(StopsPlace);
